"use client";

import { ChevronRightCircle } from "lucide-react";

import { JetSmartButton } from "@repo/ui/components/common/forms/JetSmartButton";

interface AffectedFlightNoticeProps {
  noticeText?: string;
  buttonText?: string;
  buttonTextMobile?: string;
  onModifyClick?: () => void;
}

const AffectedFlightNotice = ({
  noticeText,
  buttonText,
  buttonTextMobile,
  onModifyClick,
}: AffectedFlightNoticeProps) => {
  const resolvedNoticeText =
    noticeText || "We apologize for the inconvenience. You can make changes or request your return";
  const resolvedButtonText = buttonText || "Modify your reservation";
  // Mobile falls back to the web label (CMS text first), so both sizes read the same.
  const resolvedButtonTextMobile = buttonTextMobile || resolvedButtonText;

  return (
    <div className="flex flex-col items-center gap-[10px] pt-4 pb-2 md:flex-row md:justify-between md:gap-3">
      <p className="text-[14px] leading-[18px] font-normal text-brand-blue text-center md:text-left md:text-[18px] md:leading-[20px] md:font-medium md:flex-1">
        {resolvedNoticeText}
      </p>

      <JetSmartButton
        bgColor="bg-brand-blue"
        hoverColor=""
        textColor="text-white"
        borderColor="border-transparent"
        icon={<ChevronRightCircle className="w-4 h-4 shrink-0" />}
        className="w-full !rounded-[30px] !py-[18px] !px-[24px] text-[14px] font-medium whitespace-nowrap md:w-auto"
        onClick={onModifyClick}
      >
        <span className="md:hidden">{resolvedButtonTextMobile}</span>
        <span className="hidden md:inline">{resolvedButtonText}</span>
      </JetSmartButton>
    </div>
  );
};

export default AffectedFlightNotice;
